import { render, staticRenderFns } from "./DocumentSignatureSection.vue?vue&type=template&id=22b34f9d&scoped=true&"
import script from "./DocumentSignatureSection.vue?vue&type=script&lang=js&"
export * from "./DocumentSignatureSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSignatureSection.vue?vue&type=style&index=0&id=22b34f9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b34f9d",
  null
  
)

export default component.exports